// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@keller/XDL/types";

export default {
    primary: {
        main: "#091F92",
        contrast: "#FFFFFF",
    },
    secondary: {
        main: "#0A0B0B",
        contrast: "#FFFFFF",
    },
    common: {
        background: "#FAFAFA",
        backgroundContrast: "#363636",
        accent: "#F8F9FA",
        accentContrast: "#363636",
        border: "#CCCCCC",
        disabled: "#CCCCCC",
        ui1: "#2946DC",
        ui2: "#010E50",
        ui4: "#EEEEEE",
        ui5: "#CCCCCC",
        ui6: "#999999",
        ui7: "#666666",
        ui8: "#000000",
        ui9: "#FAFAFA",
        ui10: "#EEEBE7",
        ui11: "#C46142",
        ui12: "#F2F2F2",
        ui13: "#E8E8E8",
        ui14: "#DFE4FA",
        ui15: "#626262",
        ui16: "#333333",
        ui17: "#F3F3F4",
        ui18: "#2F2F2F",
        ui19: "#626262",
        ui20: "#F3F3F3",
        ui21: "#979797",
        white: "#FFFFFF",
    },
    text: {
        main: "#333333",
        disabled: "#475353",
        accent: "#2D3435",
        link: "#091F92",
    },
    success: {
        main: "#00A65A",
        contrast: "#FFFFFF",
        light: "#D9F2E7",
    },
    danger: {
        main: "#E4104E",
        contrast: "#FFFFFF",
        light: "#FBDBE5",
    },
    warning: {
        main: "#F1D622",
        contrast: "#FFFFFF",
        light: "#FDF9DE",
    },
    info: {
        main: "#53ACDB",
        contrast: "#FFFFFF",
        light: "#DDEEF8",
    },
} as xBaseTheme["colors"];
